import Storage from './storage'
import { Decrypt, Encrypt } from './encrypt'

const _storage_key = Encrypt('__user__local__info')
const _person = Storage.get(_storage_key)
const person = _person ? JSON.parse(Decrypt(_person)) : {
  isLogin: false,
  autoLogin: false,
  lastAccount: '',
  lastPassword: '',
  token: '',
  keepLogin: false,
  expireTime: -1,
  loginTime: -1,
  info: {}
  // courseStauts: {},
  // courseMenuInfo: {},
  // lastMenuid: {}
}
person.isLogin = person.isLogin || false
person.autoLogin = person.autoLogin || false
person.token = person.token || ''
person.keepLogin = person.keepLogin || false
person.expireTime = person.expireTime || -1
person.loginTime = person.loginTime || new Date().getTime()
person.info = person.info || {}
person.gradeInfo = person.gradeInfo || {}
// person.courseMenuInfo = person.courseMenuInfo || {}
// person.lastMenuid = person.lastMenuid || {}

function savePerson () {
  if (person) {
    Storage.set(_storage_key, Encrypt(JSON.stringify(person)))
  }
}

export const Person = {
  saveAccount: function (account) {
    person.lastAccount = account
    savePerson()
  },
  savePassword: function (password) {
    person.lastPassword = password
    savePerson()
  },
  isSavePassword: function () {
    return person.savePassword || false
  },
  savePasswordFlag: function (savePassword) {
    person.savePassword = savePassword
    savePerson()
  },
  saveToken: function (token, keepLogin = false, expireDay = 1) {
    person.isLogin = true
    person.token = token
    person.loginTime = new Date().getTime()
    if (keepLogin) {
      expireDay = expireDay || 1
      if (expireDay < 0) {
        person.expireTime = -1
      } else {
        person.expireTime = person.loginTime + expireDay * 86400 * 1000
      }
    } else {
      person.expireTime = person.loginTime + 1 * 86400 * 1000
    }
    savePerson()
  },
  saveAutoLogin: function (autoLogin) {
    person.autoLogin = autoLogin
    savePerson()
  },
  saveInfo: function (info) {
    person.info = info
    savePerson()
  },
  saveGradeInfo: function (gradeInfo) {
    person.gradeInfo = gradeInfo
    savePerson()
  },
  savePayCertPicList: function (payCertList) {
    person.info.hasUploadedPayCert = true
    person.info.payCertPicList = payCertList
    savePerson()
  },
  isLogin: function () {
    return (person.expireTime < 0 || person.expireTime > new Date().getTime()) && person.isLogin
  },
  keepLogin: function () {
    return person.keepLogin || false
  },
  lastAccount: function () {
    return person.lastAccount || ''
  },
  lastPassword: function () {
    return person.lastPassword || ''
  },
  token: function () {
    return person.token || ''
  },
  autoLogin: function () {
    return person.autoLogin || false
  },
  info: function () {
    // return Storage.getLsData("userName")
    return person.info
  },
  name: function () {
    // return Storage.getLsData("userName")
    return person.info.name
  },
  photo: function () {
    // return Storage.getLsData("userName")
    return person.info.photo
  },
  mobilePhone: function () {
    // return Storage.getLsData("userName")
    return person.info.mobilePhone
  },
  gender: function () {
    // return Storage.getLsData("userName")
    return person.info.gender
  },
  catId: function () {
    // return Storage.getLsData("userName")
    return person.info.catId
  },
  collegeId: function () {
    // return Storage.getLsData("userName")
    return person.info.collegeId
  },
  identificationCardCode: function () {
    // return Storage.getLsData("userName")
    return person.info.identificationCardCode
  },
  gradeInfo: function () {
    return person.gradeInfo
  },
  registStatus: function () {
    return person.gradeInfo ? person.gradeInfo.registStatus : null
  },
  canUploadedPayCert: function () {
    return person.info.canUploadedPayCert
  },
  hasUploadedPayCert: function () {
    return person.info.hasUploadedPayCert
  },
  confirmPayCert: function () {
    return person.info.confirmPayCert
  },
  payCertPicList: function () {
    return person.info.payCertPicList
  },
  // sign: function () {
  //   // return Storage.getLsData("userName")
  //   return person.info.sign
  // },
  userLoginName: function () {
    // return Storage.getLsData("userLoginName")
    return person.info.userLoginName
  },
  userPortrait: function () {
    // return Storage.getLsData("userPortrait")
    return person.info.portrait
  },
  // internalTag: function () {
  //   // return Storage.getLsData("userPortrait")
  //   return person.info.internalTag
  // },
  // messageCount: function () {
  //   return person.info.messageCount
  // },
  // courseStatus: function (courseId) {
  //   // return Storage.getLsData("courseStauts#"+courseId)
  //   return person.courseStauts[courseId]
  // },
  // courseMenuInfo: function (courseId) {
  //   // return Storage.getLsData("courseStauts#"+courseId)
  //   return person.courseMenuInfo[courseId]
  // },
  // lastMenuid: function (courseId, lastMenuid) {
  //   return lastMenuid || person.lastMenuid[courseId]
  // },
  // setCourseStatus: function (courseId, status) {
  //   person.courseStauts[courseId] = status
  //   savePerson()
  //   // Storage.setLsData("courseStauts#"+courseId, status)
  // },
  // setCourseMenuInfo: function (courseId, courseMenuInfo) {
  //   person.courseMenuInfo[courseId] = courseMenuInfo
  //   person.courseStauts[courseId] = courseMenuInfo.isOver
  //   savePerson()
  // },
  // setLastMenuid: function (courseId, lastMenuid) {
  //   person.lastMenuid[courseId] = lastMenuid
  //   savePerson()
  // },
  setUserName: function (userName) {
    // Storage.setLsData("userName", userName)
    person.info.userName = userName
    savePerson()
  },
  setUserLoginName: function (userLoginName) {
    // Storage.setLsData("userLoginName", userLoginName)
    person.info.userLoginName = userLoginName
    savePerson()
  },
  setName: function (name) {
    // Storage.setLsData("userName", userName)
    person.info.name = name
    savePerson()
  },
  // setInternalTag: function (internalTag) {
  //   person.info.internalTag = internalTag
  //   savePerson()
  // },
  // setMessageCount: function (messageCount) {
  //   person.info.messageCount = messageCount
  //   savePerson()
  // },
  logOut () {
    person.isLogin = false
    person.autoLogin = false
    person.token = ''
    person.expireTime = -1
    person.loginTime = new Date().getTime()
    person.info = {}
    savePerson()
    // localStorage.removeItem('myInfo')
    // localStorage.removeItem('selfExamList')
    // localStorage.removeItem('adultExamList')
    // localStorage.removeItem('retentionInfo')
  }
}



// WEBPACK FOOTER //
// ./src/utils/userinfo.js